document.addEventListener("DOMContentLoaded", () => {
	const wrap = document.querySelector(".quiz-content__wrapper .wpcf7");
	const form = wrap?.querySelector("form.wpcf7-form");
	const thanks = document.querySelector(
		".quiz-content__wrapper .quiz-thanks",
	);

	if (!form || !thanks) return;

	const getSubmitBtn = () => form.querySelector('[type="submit"]');

	form.addEventListener("submit", () => {
		const btn = getSubmitBtn();
		if (btn) btn.disabled = true;
	});

	const unlock = (e) => {
		if (e.target !== form) return;
		const btn = getSubmitBtn();
		if (btn) btn.disabled = false;
	};

	document.addEventListener("wpcf7invalid", unlock, true);
	document.addEventListener("wpcf7spam", unlock, true);
	document.addEventListener("wpcf7mailfailed", unlock, true);

	document.addEventListener(
		"wpcf7mailsent",
		(e) => {
			if (e.target !== form) return;

			wrap.style.display = "none";

			thanks.hidden = false;
			thanks.setAttribute("aria-hidden", "false");

			if (typeof window.quizProgressSetDone === "function") {
				window.quizProgressSetDone();
			}
		},
		true,
	);
});
